module.exports = __webpack_public_path__ + "static/media/undraw_business_shop_qw5t.f78acbc2.svg";